<template>
  <v-footer id="core-footer" color="#4dc8ed" style="height: inherit">
    <v-layout
      class="footer"
      row
      wrap
      :style="
        $vuetify.breakpoint.mdAndDown && $vuetify.breakpoint.smAndUp
          ? 'text-align: center'
          : ''
      "
    >
      <v-flex xs12 md5>
        <v-layout row wrap>
          <v-flex xs12>
            <h3 class="heading" style="font-size: 1.3rem !important">
              We are 100% Charitable: CC56521
            </h3>
          </v-flex>
          <!-- <v-flex xs12>
            <v-icon color="white" class="mr-1">mdi-facebook</v-icon>
            <v-icon color="white" class="mx-1">mdi-instagram</v-icon>
            <v-icon color="white" class="mx-1">mdi-linkedin</v-icon>
          </v-flex> -->
          <v-flex xs12>
            <div class="socialLogos">
              <a href="https://www.facebook.com/UpstreamNZ/" class="mr-2">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FSocial%20icons-05%20(1).svg?alt=media&token=39e38868-d544-4b4f-ab35-53040c705e72"
                  alt="Link to Facebook"
                />
              </a>
              <a href="https://www.instagram.com/upstream_nz/" class="mr-2">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FSocial%20icons-07%20(1).svg?alt=media&token=99ca6c38-1f55-446a-badf-6030850d5986"
                  alt="Link to Instagram"
                />
              </a>
              <a href="https://www.linkedin.com/company/upstreamnz/">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FSocial%20icons-06%20(1).svg?alt=media&token=3af00710-ee80-4979-92ea-5691fad7a847"
                  alt="Link to LinkedIn"
                />
              </a>
              <a
                href="https://www.youtube.com/watch?v=q9Cb0MG0s7k"
                alt="Link to Youtube"
              >
                <v-icon
                  dark
                  x-large
                  style="width: 30px; height: 37px; margin-left: 10px"
                >
                  mdi-youtube
                </v-icon>
              </a>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4>
        <v-layout row wrap class="mt-4">
          <v-flex xs4 style="cursor: pointer" @click="$router.push('/')">
            Home
          </v-flex>
          <v-flex xs4 style="cursor: pointer" @click="$router.push('/about')">
            About
          </v-flex>
          <v-flex
            xs4
            style="cursor: pointer"
            @click="$router.push('/GoodCauses')"
          >
            Good Causes
          </v-flex>
          <v-flex
            xs4
            style="cursor: pointer"
            @click="$router.push('/searchResults')"
          >
            Suppliers
          </v-flex>
          <v-flex xs4 style="cursor: pointer" @click="$router.push('/contact')">
            Contact
          </v-flex>
          <v-flex xs4 style="cursor: pointer" @click="$router.push('/about')">
            Impact Areas
          </v-flex>
          <v-flex
            v-if="user.auth == null"
            xs4
            style="cursor: pointer"
            @click="$router.push('/login')"
          >
            Login
          </v-flex>
          <v-flex xs4 style="cursor: pointer" @click="openTAndCs">
            T&C Privacy
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md3>
        <v-layout row wrap>
          <v-flex xs12>
            <div
              v-if="
                $vuetify.breakpoint.mdAndDown && $vuetify.breakpoint.smAndUp
              "
              class="logoContainerTablet"
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fupstream-recolored.svg?alt=media&token=459f94c8-d144-4e20-9910-7764d7740b18"
                alt="Upstream logo"
                class="logo"
                @click="$router.push('/')"
              />
            </div>
            <div
              v-else
              class="logoContainer"
              :class="{
                mobileFooterLogo: $vuetify.breakpoint.smAndDown,
              }"
            >
              <!-- <v-img
                src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FUpstream%20Hero%20Logo-06.svg?alt=media&token=0416061c-86ff-4b85-9edd-6ea6230e7229"
                contain
                class="logo"
                @click="$router.push('/')"
              /> -->
              <img
                src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fupstream-recolored.svg?alt=media&token=459f94c8-d144-4e20-9910-7764d7740b18"
                alt="Upstream logo"
                class="logo"
                @click="$router.push('/')"
              />
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
    }),
  },
  data: () => ({}),
  methods: {
    openTAndCs() {
      window.open(
        "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/TandCs/Upstream+combined+T%26C_Privacy+Policy.pdf",
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss">
.footer {
  max-width: 1600px;
  padding: 20px 0px 20px 0px;
  margin: auto;
  color: white;

  .heading {
    color: white;
    font-weight: 500 !important;
  }

  .logoContainer {
    width: 200px;
    height: 100px;
    margin: auto;
    position: relative;

    .logo {
      cursor: pointer;
      width: 200px;
      margin: 0;
      position: absolute;
      top: 50%;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }

  .logoContainerTablet {
    width: 100%;
    height: 100px;
    margin: auto;
    position: relative;

    .logo {
      cursor: pointer;
      width: 200px;
      margin: 0;
      position: relative;
      top: 50%;
      -ms-transform: translateY(-50%) translateX(-50%);
      transform: translateY(-50%) transformX(-50%);
    }
  }
  .mobileFooterLogo {
    margin: 0 !important;
  }

  .socialLogos {
    a img {
      width: 30px;
      height: 30px;
    }
  }
}
</style>

<style>
#core-footer {
  position: relative;
  z-index: 10;
}

#footerHeader {
  font-size: 15pt !important;
}

#footerSubheader {
  font-size: 12pt !important;
}

.footerContainer {
  width: 600px;
  margin: auto;
}

.facebookPadding {
  padding-left: 42px;
}

#mainFooterHeader {
  display: none;
}

#pageLinksFooter {
  padding-top: 40px;
}

@media screen and (max-width: 960px) {
  #footerHeader2 {
    display: none !important;
  }
  #mainFooterHeader {
    display: block !important;
  }
  #pageLinksFooter {
    padding-top: 0px;
  }
}
</style>
